import devWarning, { resetWarned } from 'rc-util/lib/warning';
export { resetWarned };
export default (valid, component, message) => {
    if (process.env.NODE_ENV !== "production")
        devWarning(valid, `[acud: ${component}] ${message}`);
};
